import React, { createContext, useContext, useEffect, useState } from 'react';

export interface ConcursoPublicadoProps {
  niveles: string;
  activo: false;
  cantidadCargoReserva: number;
  cantidadCargoSinReserva: number;
  esComite: boolean;
  esCoordinadorConcursal: boolean;
  idLlamadoConcurso: number;
  jurisdiccion: 'Poder Judicial';
  tipoConcurso: TipoConcursoProps;
  etapaLlamadoConcurso: EtapaLlamadoConcurso;
  descripcion: string;
  titulo: string;
}

interface OrganismoProps {
  codigoJOrganismo: string;
  descripcion: string;
  idJurisdiccion: number;
  idOrganismo: number;
  nombre: string;
}

interface TipoConcursoProps {
  descripcion: string;
  idTipoConcurso: number;
  nombre: string;
}

export interface EtapaLlamadoConcurso {
  idEtapaLlamadoConcurso: number;
  nombre: string;
  descripcion: string;
  llamadosConcurso: any;
}

interface ExpteLlamadoConcurso {
  factaCopic: string;
  fintervencionDgydcp: string;
  fintervencionDndo: string | null;
  fsolicitudDgydcp: string;
  fsolicitudDndo: string | null;
  fresolucionBora: string | null;
  linkResolucionBora: string;
  idExpedienteLlamadoConcurso: number;
  idLlamadoConcurso: number;
  nroActaCopic: string;
  nroExpedienteAsignacion: string;
  nroIfIntervencionDsps: string;
  nroInfSolAsignacionVacante: string;
  nroIntervencionDgydcp: string;
  nroIntervencionDndo: string | null;
  nroProda: string;
  nroSolicitudDgydcp: string;
  nroSolicitudDndo: string | null;
  nroTrataAsignacionConvocatoria: string;
  nroResolucionBora: string | null;
  pathDocumentoActaCopic: string | null;
  pathDocumentoIntervencionDgydcp: string | null;
  pathDocumentoIntervencionDndo: string | null;
  pathDocumentoProda: string | null;
  pathDocumentoSolicitudDgydcp: string | null;
  pathDocumentoSolicitudDndo: string | null;
}

interface UsuarioProps {
  apellildoUsuario: string;
  dniUsuario: string;
  emailUsuario: string;
  fconvocatoriaNota: string | null;
  frespuestaNota: string | null;
  idUsuario: number;
  idUsuarioComite: number;
  nombreUsuario: string;
  nroConvocatoriaNota: string;
  nroRespuestaNota: string;
  pathDocumentoConvocatoriaNota: string | null;
  pathDocumentoRespuestaNota: string | null;
  representacion: string;
  rolComite: {
    idRolComite: number;
    nombre: string;
    descripcion: string;
  };
  telefonoUsuario: string;
  titular: boolean;
}

interface ComiteProps {
  idComite: number;
  idLlamadoConcurso: number;
  nombreComite: string;
  resolucion: string;
  usuarios: UsuarioProps;
}

interface RequisitoProps {
  idRequisitoLlamadoConcurso: number;
  nombre: string;
  descripcion: string;
  requerido: boolean;
}

export interface ConcursoProps {
  activo: boolean;
  cantidadCargoReserva: number;
  cantidadCargoSinReserva: number;
  comite: ComiteProps[];
  esCoordinadorConcursal: boolean;
  esComite: boolean;
  etapaLlamadoConcurso: EtapaLlamadoConcurso;
  expedienteLlamadoConcurso: ExpteLlamadoConcurso;
  fcreacion: Date;
  fmodificacion: Date;
  funcionEjecutiva: boolean;
  idLlamadoConcurso: number;
  nroExpedienteAsignacion: string;
  organismo: OrganismoProps;
  pathDocumentoDenominacionCargo: string;
  publicado: boolean;
  tipoConcurso: TipoConcursoProps;
  titulo: string;
  requisitoLlamadoConcurso: RequisitoProps;
}

const ConcursoContext = createContext<ConcursoProps | null>(null);

type Props = React.PropsWithChildren<{ concurso: ConcursoProps }>;

export const ConcursoProvider = (props: Props) => {
  const { concurso, children } = props;
  const [state, setState] = useState(concurso);

  useEffect(() => {
    setState(concurso);
  }, [concurso]);

  return <ConcursoContext.Provider value={state}>{children}</ConcursoContext.Provider>;
};

export const useConcurso = () => {
  const concurso = useContext(ConcursoContext);
  if (!concurso) throw new Error('No se pasó nigun concurso');

  return concurso;
};
